import React from 'react'
import { Navigate } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

interface SubscriptionGuardProps {
  children: React.ReactNode
}

export function SubscriptionGuard({ children }: SubscriptionGuardProps) {
  const { subscription, hasActiveSubscription, loading } = useAuth()

  const queryMode = new URLSearchParams(window.location.search).get('sub') || new URLSearchParams(window.location.search).get('mode')
  const persistedMode = sessionStorage.getItem('preferred_subscription_mode') || localStorage.getItem('preferred_subscription_mode')
  const isDirect2Mode = queryMode === 'direct2' || persistedMode === 'direct2'

  // Si on est encore en train de charger, on affiche un loader
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Checking subscription...</p>
        </div>
      </div>
    )
  }

  // Laisser tous les utilisateurs accéder au dashboard (map).
  // Le blocage se fait sur l'action "STATIONNER ICI" si pas d'abonnement actif.

  console.log('✅ SubscriptionGuard: Active subscription found, allowing access')
  console.log('📋 Current subscription:', subscription)
  return <>{children}</>
}
